import { AsyncComponentQuoteEnum, quoteComponents } from './asyncComponent/asyncQuote';

import type { AsyncComponentOptions, Component } from 'vue';
//import { VDataTableComponent } from './asyncLoading';
import ErrorLoadingComponent from '@/components/shared/ErrorLoadingComponent.vue'; //'@/components/shared/ErrorLoadingComponent.vue'
import LoadingButton from '@/components/shared/LoadingButton.vue';
import LoadingHeading from '@/components/shared/LoadingHeading.vue';
import LoadingTwoLines from '@/components/shared/LoadingTwoLines.vue';
import LoadingView from '@/components/shared/LoadingView.vue';
import { defineAsyncComponent, h } from 'vue';
import { AsyncComponentCompanyEnum, companyComponents } from './asyncComponent/asyncCompany';
import { AsyncComponentLayoutEnum, layoutComponents } from './asyncComponent/asyncLayout';
import { AsyncComponentMeasureEnum, measureComponents } from './asyncComponent/asyncMeasure';
import { AsyncComponentOptionalEnum, optionalComponents } from './asyncComponent/asyncOptional';
import { AsyncComponentPantoneEnum, pantoneComponents } from './asyncComponent/asyncPantone';
import { AsyncComponentPriceEnum, priceComponents } from './asyncComponent/asyncPrice';
import { AsyncComponentProductModelEnum, productModelComponents } from './asyncComponent/asyncProductModel';
import { AsyncComponentRegistryEnum, registryComponents } from './asyncComponent/asyncRegistry';
import { AsyncComponentSharedEnum, sharedComponents } from './asyncComponent/asyncShared';
import { AsyncComponentSuperAdminEnum, superAdminComponents } from './asyncComponent/asyncSuperAdmin';
import { AsyncComponentUserEnum, userComponents } from './asyncComponent/asyncUser';


export const LoadingViewComponent = LoadingView

export const LoadingTwoLinesComponent = LoadingTwoLines

export const LoadingHeadingComponent = LoadingHeading

export const AsyncComponentList = {

  //...AsyncComponentCompanyEnum,  
  //...AsyncComponentSuperAdminEnum,
  ...AsyncComponentSharedEnum,
  ...AsyncComponentLayoutEnum,
  ...AsyncComponentUserEnum,
  ...AsyncComponentCompanyEnum,
  ...AsyncComponentProductModelEnum,
  ...AsyncComponentPantoneEnum,
  ...AsyncComponentOptionalEnum,
  ...AsyncComponentMeasureEnum,
  ...AsyncComponentSuperAdminEnum,
  ...AsyncComponentRegistryEnum,
  ...AsyncComponentQuoteEnum,
  ...AsyncComponentPriceEnum,

  // Qui puoi aggiungere altri enum in futuro...
} as const

export const componentMap: Record<keyof typeof AsyncComponentList, () => Promise<any>> = {
  /*.,
  ...companyComponents,
  ...registryComponents,
  ...superAdminComponents,*/
  ...sharedComponents,
  ...layoutComponents,
  ...userComponents,
  ...companyComponents,
  ...productModelComponents,
  ...pantoneComponents,
  ...optionalComponents,
  ...measureComponents,
  ...superAdminComponents,
  ...registryComponents,
  ...quoteComponents,
  ...priceComponents,
}

type AsyncExtraOptions = Pick<AsyncComponentOptions, 'suspensible' | 'delay' | 'onError' | 'timeout'>


export function defaultAsync (
  componentName: keyof typeof AsyncComponentList,
  loadingComponent: Component = LoadingTwoLinesComponent,
  extra: AsyncExtraOptions = {}
) {
  if ( !componentMap[ componentName ] )
  {
    throw new Error( `Component "${ componentName }" not found in componentMap` )
  }

  // onError di default, tipizzato
  const defaultOnError: NonNullable<AsyncComponentOptions[ 'onError' ]> = (
    error: Error,
    retry: () => void,
    fail: () => void,
    attempts: number
  ) => {
    // retry "soft" per errori transient
    if ( attempts <= 2 ) retry()
    else fail()
  }


  const { suspensible = false, delay = 0, onError, timeout = 15000 } = extra

  const options: AsyncComponentOptions = {
    loader: () =>
      componentMap[ componentName ]().catch( ( e ) => {
        console.error( '[async] loader rejected', componentName, e );
        throw e;
      } ),
    loadingComponent,
    errorComponent: () => h( ErrorLoadingComponent, { component: componentName } ),
    timeout,                 // <— solo da parametro
    suspensible,
    delay,
    onError: onError ?? defaultOnError,
  }

  return defineAsyncComponent( options )
}

//ANCHOR - Shared Components
export const PublicView = defaultAsync( AsyncComponentList.PublicView, LoadingView )
export const ImageCropper = defaultAsync( AsyncComponentList.ImageCropper )
export const ImageViewWithCropper = defaultAsync( AsyncComponentList.ImageViewWithCropper )
export const ViewDefault = defaultAsync( AsyncComponentList.ViewDefault )
export const ViewList = defaultAsync( AsyncComponentList.ViewList )
export const FormDefault = defaultAsync( AsyncComponentList.FormDefault )
export const ActionMenu = defaultAsync( AsyncComponentList.ActionMenu )
export const ConfirmDelete = defaultAsync( AsyncComponentList.ConfirmDelete )
export const TextField = defaultAsync( AsyncComponentList.TextField )
export const TabManager = defaultAsync( AsyncComponentList.TabManager )
export const Editor = defaultAsync( AsyncComponentList.Editor, LoadingView )
export const ColorAvatar = defaultAsync( AsyncComponentList.ColorAvatar, LoadingView, { suspensible: false, delay: 0 } )
export const ColorPicker = defaultAsync( AsyncComponentList.ColorPicker )
export const ProductModelAvatar = defaultAsync( AsyncComponentList.ProductModelAvatar, LoadingButton )
export const OptionalAvatar = defaultAsync( AsyncComponentList.OptionalAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const Name = defaultAsync( AsyncComponentList.Name, LoadingButton )
export const Amount = defaultAsync( AsyncComponentSharedEnum.Amount, LoadingButton )
export const Measure = defaultAsync( AsyncComponentSharedEnum.Measure, LoadingButton )
export const YesNoOptionalSelector = defaultAsync( AsyncComponentSharedEnum.YesNoOptionalSelector, LoadingButton )
export const OptionalDetailAvatar = defaultAsync( AsyncComponentSharedEnum.OptionalDetailAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const MaterialTypeAvatar = defaultAsync( AsyncComponentSharedEnum.MaterialTypeAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const MaterialTypeSelector = defaultAsync( AsyncComponentSharedEnum.MaterialTypeSelector, LoadingButton )
export const HandleSelector = defaultAsync( AsyncComponentSharedEnum.HandleSelector, LoadingButton )
export const ProductModelOptionalDetailSelector = defaultAsync( AsyncComponentSharedEnum.ProductModelOptionalDetailSelector, LoadingTwoLines )
export const ItemHtml = defaultAsync( AsyncComponentSharedEnum.ItemHtml, LoadingButton )
export const YesNoOptionalText = defaultAsync( AsyncComponentSharedEnum.YesNoOptionalText )
export const DocStatusAvatar = defaultAsync( AsyncComponentSharedEnum.DocStatusAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const DocStatusSelector = defaultAsync( AsyncComponentSharedEnum.DocStatusSelector, LoadingButton )
export const AddNewBtn = defaultAsync( AsyncComponentSharedEnum.AddNewBtn, LoadingButton, { suspensible: false, delay: 0 } )
export const CompanySelector = defaultAsync( AsyncComponentSharedEnum.CompanySelector, LoadingTwoLines )
export const InputType = defaultAsync( AsyncComponentSharedEnum.InputType, LoadingTwoLines )
export const NumberInput = defaultAsync( AsyncComponentSharedEnum.NumberInput, LoadingTwoLines )
export const LogoAvatar = defaultAsync( AsyncComponentSharedEnum.LogoAvatar, LoadingButton )
export const UserRoleAvatar = defaultAsync( AsyncComponentSharedEnum.UserRoleAvatar, LoadingButton )
export const WelcomeCompanyCard = defaultAsync( AsyncComponentSharedEnum.WelcomeCompanyCard, LoadingView )
export const MultiActions = defaultAsync( AsyncComponentSharedEnum.MultiActions, LoadingButton )
export const DatePicker = defaultAsync( AsyncComponentSharedEnum.DatePicker, LoadingTwoLines )

//ANCHOR - Layout Components
export const Logo = defaultAsync( AsyncComponentLayoutEnum.Logo )
export const LogoIcon = defaultAsync( AsyncComponentLayoutEnum.LogoIcon )
export const Customizer = defaultAsync( AsyncComponentLayoutEnum.Customizer, LoadingButton )
export const HorizontalHeader = defaultAsync( AsyncComponentLayoutEnum.HorizontalHeader, LoadingHeading )
export const HorizontalSidebar = defaultAsync( AsyncComponentLayoutEnum.HorizontalSidebar, LoadingTwoLines )
export const VerticalHeaderVue = defaultAsync( AsyncComponentLayoutEnum.VerticalHeaderVue, LoadingHeading )
export const VerticalSidebarVue = defaultAsync( AsyncComponentLayoutEnum.VerticalSidebarVue, LoadingTwoLines )


//ANCHOR - User Components
export const UserMutate = defaultAsync( AsyncComponentList.UserMutate, LoadingView )
export const UserList = defaultAsync( AsyncComponentList.UserList, LoadingView )

//ANCHOR - Company Components
export const CompanySettings = defaultAsync( AsyncComponentList.CompanySettings, LoadingView )
export const CompanyProfile = defaultAsync( AsyncComponentList.CompanyProfile, LoadingView )
export const AccountSettings = defaultAsync( AsyncComponentList.AccountSettings, LoadingView )
export const CompanyListForm = defaultAsync( AsyncComponentList.CompanyListForm, LoadingView )
export const CompanyMutate = defaultAsync( AsyncComponentList.CompanyMutate, LoadingView )
export const CompanyTabs = defaultAsync( AsyncComponentList.CompanyTabs, LoadingView )
export const CompanyList = defaultAsync( AsyncComponentList.CompanyList, LoadingView )
/*export const CompanyData = defaultAsync( AsyncComponentList.CompanyData )
export const CompanyListCompany = defaultAsync( AsyncComponentList.CompanyListCompany )
export const LinkProcedureCompanySelector = defaultAsync(
  AsyncComponentList.LinkProcedureCompanySelector,
  LoadingTwoLines,
)*/

export const ProductModelMutate = defaultAsync( AsyncComponentProductModelEnum.ProductModelMutate, LoadingView )
export const ProductModelMutateForm = defaultAsync( AsyncComponentProductModelEnum.ProductModelMutateForm, LoadingView )
export const ProductModelList = defaultAsync( AsyncComponentProductModelEnum.ProductModelList, LoadingView )
export const ProductModelTabs = defaultAsync( AsyncComponentProductModelEnum.ProductModelTabs, LoadingView )
export const ProductModelListForm = defaultAsync( AsyncComponentProductModelEnum.ProductModelListForm, LoadingView )
export const ProductModelSelector = defaultAsync( AsyncComponentProductModelEnum.ProductModelSelector, LoadingTwoLines )
export const ProductModelManage = defaultAsync( AsyncComponentProductModelEnum.ProductModelManage, LoadingView )
export const ProductModelOptional = defaultAsync( AsyncComponentProductModelEnum.ProductModelOptional, LoadingView )
export const ProductModelColorSelector = defaultAsync( AsyncComponentProductModelEnum.ProductModelColorSelector, LoadingTwoLines )

//export const SuperAdminTabs = defaultAsync( AsyncComponentList.SuperAdminTabs )
export const PantoneMutate = defaultAsync( AsyncComponentList.PantoneMutate, LoadingView )
export const PantoneMutateForm = defaultAsync( AsyncComponentList.PantoneMutateForm, LoadingView )
export const PantoneList = defaultAsync( AsyncComponentList.PantoneList, LoadingView )
export const PantoneListForm = defaultAsync( AsyncComponentList.PantoneListForm, LoadingView )
export const PantoneTabs = defaultAsync( AsyncComponentList.PantoneTabs, LoadingView )
export const ColorList = defaultAsync( AsyncComponentList.ColorList, LoadingView )
export const ColorListForm = defaultAsync( AsyncComponentList.ColorListForm, LoadingView )
export const ColorMutateForm = defaultAsync( AsyncComponentList.ColorMutateForm, LoadingView )
export const ColorMutate = defaultAsync( AsyncComponentList.ColorMutate, LoadingView )
export const PantoneColor = defaultAsync( AsyncComponentPantoneEnum.PantoneColor, LoadingView )
export const PantoneSelector = defaultAsync( AsyncComponentPantoneEnum.PantoneSelector, LoadingView )
export const ColorSelector = defaultAsync( AsyncComponentPantoneEnum.ColorSelector, LoadingView )
export const PantoneProductModel = defaultAsync( AsyncComponentPantoneEnum.PantoneProductModel, LoadingView )
export const MaterialTypeColorSelector = defaultAsync( AsyncComponentPantoneEnum.MaterialTypeColorSelector, LoadingTwoLines )
export const QuoteDetailTypeAvatar = defaultAsync( AsyncComponentSharedEnum.QuoteDetailTypeAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const QuoteDetailTypeSelector = defaultAsync( AsyncComponentSharedEnum.QuoteDetailTypeSelector, LoadingButton )
export const SideAvatar = defaultAsync( AsyncComponentSharedEnum.SideAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const SideSelector = defaultAsync( AsyncComponentSharedEnum.SideSelector, LoadingButton )
export const DimensionTypeAvatar = defaultAsync( AsyncComponentSharedEnum.DimensionTypeAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const DimensionTypeSelector = defaultAsync( AsyncComponentSharedEnum.DimensionTypeSelector, LoadingButton )
export const QuoteTypeAvatar = defaultAsync( AsyncComponentSharedEnum.QuoteTypeAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const QuoteTypeSelector = defaultAsync( AsyncComponentSharedEnum.QuoteTypeSelector, LoadingButton )
export const MultimediaManager = defaultAsync( AsyncComponentSharedEnum.MultimediaManager, LoadingView )
export const TrueFalseAvatar = defaultAsync( AsyncComponentSharedEnum.TrueFalseAvatar, LoadingButton )
export const AccessoryAvatar = defaultAsync( AsyncComponentSharedEnum.AccessoryAvatar, LoadingButton, { suspensible: false, delay: 0 } )
export const PriceSection = defaultAsync( AsyncComponentSharedEnum.PriceSection, LoadingTwoLines )
export const PriceView = defaultAsync( AsyncComponentSharedEnum.PriceView, LoadingTwoLines )

export const OptionalMutate = defaultAsync( AsyncComponentOptionalEnum.OptionalMutate, LoadingView )
export const OptionalMutateForm = defaultAsync( AsyncComponentOptionalEnum.OptionalMutateForm, LoadingView )
export const OptionalList = defaultAsync( AsyncComponentOptionalEnum.OptionalList, LoadingView )
export const OptionalListForm = defaultAsync( AsyncComponentOptionalEnum.OptionalListForm, LoadingView )
export const OptionalTabs = defaultAsync( AsyncComponentOptionalEnum.OptionalTabs, LoadingView )
export const OptionalDetailMutateForm = defaultAsync( AsyncComponentOptionalEnum.OptionalDetailMutateForm, LoadingView )
export const OptionalDetailMutate = defaultAsync( AsyncComponentOptionalEnum.OptionalDetailMutate,
  LoadingView )
export const OptionalDetailListForm = defaultAsync( AsyncComponentOptionalEnum.OptionalDetailListForm,
  LoadingView )
export const OptionalDetailList = defaultAsync( AsyncComponentOptionalEnum.OptionalDetailList, LoadingView )
export const OptionalSelector = defaultAsync( AsyncComponentOptionalEnum.OptionalSelector, LoadingTwoLines )
export const OptionalDetailSelector = defaultAsync( AsyncComponentOptionalEnum.OptionalDetailSelector, LoadingTwoLines )
export const OptionalVisibilityGate = defaultAsync( AsyncComponentOptionalEnum.OptionalVisibilityGate, LoadingTwoLines )
export const AccessoryMutate = defaultAsync( AsyncComponentOptionalEnum.AccessoryMutate, LoadingView )
export const AccessoryTabs = defaultAsync( AsyncComponentOptionalEnum.AccessoryTabs, LoadingView )
export const AccessoryList = defaultAsync( AsyncComponentOptionalEnum.AccessoryList, LoadingView )
export const AccessoryMutateForm = defaultAsync( AsyncComponentOptionalEnum.AccessoryMutateForm, LoadingView )
export const AccessorySelector = defaultAsync( AsyncComponentOptionalEnum.AccessorySelector, LoadingTwoLines )

export const MeasureTabs = defaultAsync( AsyncComponentMeasureEnum.MeasureTabs, LoadingView )
export const MeasureListForm = defaultAsync( AsyncComponentMeasureEnum.MeasureListForm, LoadingView )
export const MeasureGroupListForm = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupListForm, LoadingView )
export const MeasureGroupMutateForm = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupMutateForm, LoadingView )
export const MeasureMutateForm = defaultAsync( AsyncComponentMeasureEnum.MeasureMutateForm, LoadingView )
export const MeasureMutate = defaultAsync( AsyncComponentMeasureEnum.MeasureMutate, LoadingView )
export const MeasureList = defaultAsync( AsyncComponentMeasureEnum.MeasureList, LoadingView )
export const MeasureGroupMutate = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupMutate, LoadingView )
export const MeasureGroupList = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupList, LoadingView )
export const MeasureGroupTabs = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupTabs, LoadingView )
export const MeasureGroupSelector = defaultAsync( AsyncComponentMeasureEnum.MeasureGroupSelector, LoadingTwoLines )
export const MeasureSelector = defaultAsync( AsyncComponentMeasureEnum.MeasureSelector, LoadingTwoLines )

export const SuperAdminTabs = defaultAsync( AsyncComponentSuperAdminEnum.SuperAdminTabs, LoadingView )
export const CodeTablesNameMutateForm = defaultAsync( AsyncComponentSuperAdminEnum.CodeTablesNameMutateForm, LoadingView )
export const CodeTablesNameListForm = defaultAsync( AsyncComponentSuperAdminEnum.CodeTablesNameListForm, LoadingView )
export const CodeTablesMutateForm = defaultAsync( AsyncComponentSuperAdminEnum.CodeTablesMutateForm, LoadingView )
export const CodeTablesListForm = defaultAsync( AsyncComponentSuperAdminEnum.CodeTablesListForm, LoadingView )
export const CodeTablesParameter = defaultAsync( AsyncComponentSuperAdminEnum.CodeTablesParameter, LoadingView )


export const RegistryTabs = defaultAsync( AsyncComponentRegistryEnum.RegistryTabs, LoadingView )
export const RegistryListForm = defaultAsync( AsyncComponentRegistryEnum.RegistryListForm, LoadingView )
export const RegistryMutateForm = defaultAsync( AsyncComponentRegistryEnum.RegistryMutateForm, LoadingView )
export const RegistryList = defaultAsync( AsyncComponentRegistryEnum.RegistryList, LoadingView )
export const RegistryMutate = defaultAsync( AsyncComponentRegistryEnum.RegistryMutate, LoadingView )
export const RegistrySelector = defaultAsync( AsyncComponentRegistryEnum.RegistrySelector, LoadingTwoLines )

export const QuoteTabs = defaultAsync( AsyncComponentQuoteEnum.QuoteTabs, LoadingView )
export const QuoteListForm = defaultAsync( AsyncComponentQuoteEnum.QuoteListForm, LoadingView )
export const QuoteMutateForm = defaultAsync( AsyncComponentQuoteEnum.QuoteMutateForm, LoadingView )
export const QuoteList = defaultAsync( AsyncComponentQuoteEnum.QuoteList, LoadingView )
export const QuoteMutate = defaultAsync( AsyncComponentQuoteEnum.QuoteMutate, LoadingView )
export const QuoteSearch = defaultAsync( AsyncComponentQuoteEnum.QuoteSearch, LoadingTwoLines )
export const QuoteStepper = defaultAsync( AsyncComponentQuoteEnum.QuoteStepper, LoadingTwoLines )
export const QuoteHeaderForm = defaultAsync( AsyncComponentQuoteEnum.QuoteHeaderForm, LoadingView )
export const QuoteOptionalDetailMutateForm = defaultAsync( AsyncComponentQuoteEnum.QuoteOptionalDetailMutateForm, LoadingTwoLines )

export const PriceGroupMeasureTabs = defaultAsync( AsyncComponentPriceEnum.PriceGroupMeasureTabs, LoadingView )
export const PriceMeasureMutateForm = defaultAsync( AsyncComponentPriceEnum.PriceMeasureMutateForm, LoadingView )
export const PriceGroupMeasureListForm = defaultAsync( AsyncComponentPriceEnum.PriceGroupMeasureListForm, LoadingView )
export const PriceGroupMeasureMutateForm = defaultAsync( AsyncComponentPriceEnum.PriceGroupMeasureMutateForm, LoadingView )
export const PriceMeasureMutate = defaultAsync( AsyncComponentPriceEnum.PriceMeasureMutate, LoadingView )
export const PriceGroupMeasureMutate = defaultAsync( AsyncComponentPriceEnum.PriceGroupMeasureMutate, LoadingView )
export const PriceMeasureListForm = defaultAsync( AsyncComponentPriceEnum.PriceMeasureListForm, LoadingView )
export const PriceMeasureList = defaultAsync( AsyncComponentPriceEnum.PriceMeasureList, LoadingView )
export const PriceTabs = defaultAsync( AsyncComponentPriceEnum.PriceTabs, LoadingView )
export const Price = defaultAsync( AsyncComponentPriceEnum.Price, LoadingView )
export const ProductModelOptionalPriceGroupMeasureMutate = defaultAsync( AsyncComponentPriceEnum.ProductModelOptionalPriceGroupMeasureMutate, LoadingView )
export const ProductModelOptionalPriceGroupMeasureMutateForm = defaultAsync( AsyncComponentPriceEnum.ProductModelOptionalPriceGroupMeasureMutateForm, LoadingView )
export const PriceMeasureMutateListForm = defaultAsync( AsyncComponentPriceEnum.PriceMeasureMutateListForm, LoadingView )
export const PriceMeasureMutateList = defaultAsync( AsyncComponentPriceEnum.PriceMeasureMutateList, LoadingView )
